import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { reduce } from 'rxjs/operators';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-relatie-add',
  templateUrl: './relatie-add.component.html',
  styleUrls: ['./relatie-add.component.less']
})
export class RelatieAddComponent implements OnInit {

  data = {
    BedrijfsNaam : '',
    Afkorting : ''
  }

  constructor(private relatiesService: RelatiesService,
              private toastr: ToastrService,
              private router: Router
              ) { }

  ngOnInit() {
  }

  save() {
    if (this.data.BedrijfsNaam == '' || this.data.Afkorting == '') {
      this.toastr.error("", "Bedrijfsnaam en Afkorting moeten worden ingevuld");
      return;
    }
    this.relatiesService.addRelatie(this.data).subscribe((res) => {
      this.router.navigateByUrl('/relaties/' + res.BedrijfNummer);
    })

  }

}
